module.exports = __webpack_public_path__ + "static/img/tab-banner1.5db26b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/3/tab-banner1.png
// module id = ujVE
// module chunks = 1